<template>
	<section class="new-event-wooba-flight-reservation">
		<div class="new-event-wooba-flight-reservation__inner new-layout-container">
			<iframe
				ref="woobaFrame"
				class="new-event-wooba-flight-reservation__frame"
				:src="woobaUrl"
				:title="title"
				frameborder="0"
				@load="handleFrameLoad"
			></iframe>
		</div>
	</section>
</template>

<script>
import { translate } from '../../assets/translations';

const WOOBA_ORIGIN = 'https://app.blumar.com.br';
const DEFAULT_FRAME_HEIGHT = 1000;
const FALLBACK_FRAME_HEIGHT = 3700;

export default {
	props: {
		event: {
			type: Object,
			required: true,
		},
		adults: {
			type: [String, Number],
			required: true,
		},
		kids: {
			type: [String, Number],
			required: true,
		},
		babies: {
			type: [String, Number],
			required: true,
		},
		origin: {
			type: String,
			required: true,
		},
		destination: {
			type: String,
			required: true,
		},
		checkin: {
			type: String,
			required: true,
		},
		checkout: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			resizeRequestTimer: null,
		};
	},
	computed: {
		title() {
			return translate(this.$store.state.language).eventPage.optionLabels.flightReservation;
		},
		woobaUrl() {
			const params = [
				['LojaChave', 'dGVzdGU='],
				['adultos', this.adults],
				['criancas', this.kids],
				['bebes', this.babies],
				['origem', this.origin],
				['destino', this.destination],
				['dataIda', this.checkin],
			];

			if (this.checkout) params.push(['dataVolta', this.checkout]);
			params.push(['evento', this.event.woobaId]);

			const query = params
				.map(([name, value]) => `${name}=${encodeURIComponent(value)}`)
				.join('&');
			return `${WOOBA_ORIGIN}/onlinetravelframemvc/aereo/disponibilidade?${query}`;
		},
	},
	mounted() {
		window.addEventListener('message', this.updateFrameHeight);
	},
	beforeDestroy() {
		window.removeEventListener('message', this.updateFrameHeight);
		if (this.resizeRequestTimer) clearTimeout(this.resizeRequestTimer);
	},
	methods: {
		handleFrameLoad() {
			const frame = this.$refs.woobaFrame;
			if (!frame) return;

			frame.style.height = `${DEFAULT_FRAME_HEIGHT}px`;
			this.requestFrameHeight();
			this.resizeRequestTimer = setTimeout(this.requestFrameHeight, 100);
		},
		requestFrameHeight() {
			const frame = this.$refs.woobaFrame;
			if (!frame || !frame.contentWindow) return;
			frame.contentWindow.postMessage('', WOOBA_ORIGIN);
		},
		updateFrameHeight(message) {
			if (message.origin !== WOOBA_ORIGIN) return;
			const frameInfo = message.data;
			const height = Number(frameInfo && frameInfo.h);
			if (!Number.isFinite(height)) return;

			const frame = this.$refs.woobaFrame;
			if (!frame) return;
			frame.style.height = `${height === 0 ? FALLBACK_FRAME_HEIGHT : height}px`;
		},
	},
};
</script>

<style scoped lang="scss">
.new-event-wooba-flight-reservation__inner {
	margin-top: 60px;
	margin-bottom: 100px;
}

.new-event-wooba-flight-reservation__frame {
	display: block;
	width: 100%;
	min-height: 1000px;
	border: 0;
	overflow: hidden;
}

@media (max-width: 600px) {
	.new-event-wooba-flight-reservation__inner {
		margin-top: 36px;
		margin-bottom: 60px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/event/WoobaFlightReservation.vue